export default "__VITE_ASSET__CQMDc1hh__"